<template lang="pug">
  md-card
    md-card-header(data-background-color="green")
      h4(class="title") Roster
      p(class="category") People in your Analyst Group
    md-card-content(style="text-align: center;")
      md-table
        md-table-row
          md-table-cell <b>Name</b>
          md-table-cell <b>Email</b>
          md-table-cell <b>Role</b>
        md-table-row(v-for="person in roster" :key="person.id")
          md-table-cell {{person.full_name}}
          md-table-cell {{person.email}}
          md-table-cell {{person.teaching_role}}
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      user: null,
      roster: null,
      error: null,
    }
  },
  props: {
    groupID: {
      type: Number,
      default: null
    }
  },
  mounted() {
    this.user = this.$store.state.user;
    this.getGroupInformation();
  },
  methods: {
    getGroupInformation() {
      axios.get(`/api/org/analyst_groups/${this.groupID}/users`)
      .then((res) => {
        this.roster = res.data;
      }).catch((err) => {
        this.error = true;
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/AnalystGroup/AnalystGroupRoster.vue